/**
 * Contextual copy for the top Nova presence banner on all TTC demo routes.
 * Dismissal is per full pathname via sessionStorage (see ChapterDemo + AppShell).
 */

const NOVA_CHAT = '/nova-chat';

export function getTtcDemoPresenceBanner(activeSection, chapterSlug, navigate) {
  const base = `/demo/${chapterSlug}`;
  const go = (to) => () => navigate(to);

  const bySection = {
    home: {
      contextPill: 'Daily check-in',
      message:
        "Your fertile window might be active — I've prepared a quick timing checklist and questions to bring in.",
      actionLabel: 'See checklist →',
      onAction: go(NOVA_CHAT),
    },
    cycle: {
      contextPill: 'Guidance',
      message:
        "Day 14 — your OPK and BBT are both signaling peak today. I've prepared your timing window summary.",
      actionLabel: 'See summary →',
      onAction: go(`${base}/cycle-intelligence`),
    },
    health: {
      contextPill: 'Guidance',
      message: 'Your lab results from Jan 15 are ready to review. Nova has added context to each value.',
      actionLabel: 'Review now →',
      onAction: go(NOVA_CHAT),
    },
    'cycle-intelligence': {
      contextPill: 'Guidance',
      message: "Nova noticed a pattern worth discussing at your next appointment. I've prepared a note.",
      actionLabel: 'See note →',
      onAction: go(NOVA_CHAT),
    },
    'cycle-school': {
      contextPill: 'Guidance',
      message:
        'Based on where you are in your cycle, Nova suggests starting with the luteal phase explainer today.',
      actionLabel: 'Start →',
      onAction: go(`${base}/resources`),
    },
    doctors: {
      contextPill: 'Clinic visit',
      message: 'Your next appointment is in 3 days. Nova has prepared your pre-appointment question list.',
      actionLabel: 'See questions →',
      onAction: go(NOVA_CHAT),
    },
    'appointment-prep': {
      contextPill: 'Clinic visit',
      message:
        'Your cycle summary is ready to share with your doctor. Nova has prepared it based on your last 4 cycles.',
      actionLabel: 'View summary →',
      onAction: go(NOVA_CHAT),
    },
  };

  const defaultBanner = {
    contextPill: 'Guidance',
    message:
      "Day 14 — you're in your fertile window. Nova can help with timing, OPKs, and what to log today.",
    actionLabel: 'Open Nova →',
    onAction: go(NOVA_CHAT),
  };

  return bySection[activeSection] || defaultBanner;
}
